import { Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { ParameterDetail } from "@/features/line-editor/hooks";
import { getParameterSourceFriendlyLabel } from "@/lib/display-labels";

interface ParameterRowProps {
  param: ParameterDetail;
  hasSensorLink: boolean;
  isView: boolean;
  removePending: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

export function ParameterRow({
  param,
  hasSensorLink,
  isView,
  removePending,
  onEdit,
  onDelete,
}: ParameterRowProps) {
  return (
    <li className="space-y-1 rounded border px-2 py-1.5 text-sm">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5">
            <p className="truncate font-medium">{param.name}</p>
            {param.category === "STATUS" ? (
              <span className="bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300 border-current/20 inline-flex shrink-0 items-center rounded-full border px-1.5 py-0 text-[10px] font-medium uppercase tracking-wider">
                Status da máquina
              </span>
            ) : null}
          </div>
          <p className="text-muted-foreground font-mono text-[10px] uppercase tracking-wider">
            {getParameterSourceFriendlyLabel(param.source)}
            {param.unit ? ` · ${param.unit}` : ""}
          </p>
          {hasSensorLink ? (
            <p className="text-[10px] text-blue-600 dark:text-blue-400">Vinculado a sensor</p>
          ) : null}
        </div>
        {!isView ? (
          <div className="flex shrink-0 gap-1">
            <Button
              size="icon"
              variant="ghost"
              aria-label={`Editar ${param.name}`}
              onClick={onEdit}
            >
              <Pencil className="h-3.5 w-3.5" />
            </Button>
            <Button
              size="icon"
              variant="ghost"
              aria-label={`Remover ${param.name}`}
              onClick={onDelete}
              disabled={removePending}
            >
              <Trash2 className="text-destructive h-3.5 w-3.5" />
            </Button>
          </div>
        ) : null}
      </div>
    </li>
  );
}
